import React from "react";
import "./stats.css";

export const Stats = () => {
  return (
    <div className="portfolio-component-3">
      <div id="content">
        <div id="side-1">
          <div id="educational-qualifications">
            <h1 id="edu-title">Educational Qualifications</h1>

            <div id="primary">
              <h2 id="primary-title">Primary</h2>
              <div id="adarsh-content">
                <p id="adarsh">Adarsh Vidhyalaya Public School Anthiyur, Tamilnadu</p>
                <p id="adarsh-year">2009-2011</p>
              </div>
              <div id="optimus-primary-content">
                <p id="optimus-primary">The Optimus Public School Bhavani, Tamilnadu</p>
                <p id="optimus-primary-year">2012-2017</p>
              </div>
            </div>

            <div id="secondary">
              <h2 id="secondary-title">Secondary and Higher Secondary</h2>
              <div id="optimus-secondary-content">
                <p id="optimus-secondary">The Optimus Public School Bhavani, Tamilnadu</p>
                <p id="optimus-secondary-year">2018-2021</p>
              </div>
            </div>
            
            <div id="grad-high">
              <h2 id="grad-high-title">Graduation (High School)</h2>
              <div id="optimus-grad-content">
                <p id="optimus-grad">The Optimus Public School Bhavani, Tamilnadu</p>
                <p id="optimus-grad-year">2022</p>
              </div>
            </div>

            <div id="ug">
              <h2 id="ug-title">Undergraduate</h2>
              <div id="vit-content">
                <p id="vit">Vellore Institute of Technology Chennai, Tamilnadu</p>
                <p id="vit-year">2022-2026</p>
              </div>
            </div>
            
          </div>
          

          <div id="softskills">
            <h1 id="softskills-title">Softskills</h1>
            <ul id="softskills-content">
              <li>Communication</li>
              <li>Problem-solving</li>
              <li>Teamwork</li>
              <li>Fast Learner</li>
              <li>Competitive</li>
              <li>Energetic</li>
              <li>Attentive to Details</li>
              <li>Experimentation</li>
            </ul>
          </div>



        </div>
          <div id="side-2">
            <div id="digital-skills">
            <h1 id="digital-title">Digital Skills</h1>
            <ul id="digital-content">
              <li>Machine Learning</li>
              <li>Deep Learning</li>
              <li>UI UX Designing</li>
              <li>Figma</li>
              <li>Solidworks</li>
              <li>MS Office Suite</li>
              <li>Canvas</li>
              <li>Adobe Express</li>
              <li>Git and Github</li>
            </ul>
          </div>
          

            <div id="computer-languages">
            <h1 id="comp-title">Computer Languages and Frameworks</h1>
            <ul id="comp-content">
              <li>Python</li>
              <li>Tensorflow</li>
              <li>C and C++</li>
              <li>Java</li>
              <li>Javascript</li>
              <li>HTML5 and CSS3</li>
              <li>Bootstrap</li>
              <li>React</li>
              <li>Node.js</li>
              <li>Express.js</li>
              <li>MySQL</li>
            </ul>
          </div>
          

          <div id="interests">
            <h1 id="interests-title">Interests</h1>
            <ul id="interests-content">
              <li>Cooking</li>
              <li>Gardening</li>
              <li>Sketching</li>
              <li>Designing</li>
              <li>Drawing</li>
              <li>Coding</li>
              <li>Playing Cricket and Football</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    );
};
    
    
export default Stats;